/* eslint-disable import/no-anonymous-default-export */
import {
    GET_CMS_SITE_SECONDARY_NAV
} from "../actions/types";

const initialState = [];
const cmsReducer = function (state=initialState, action) {
    const {type, payload } = action;
    switch (type) {        
        case GET_CMS_SITE_SECONDARY_NAV:
            return {
                ...state,
                contentNavbar: payload
            }        
        default:
            return state;
    }
};

export default cmsReducer;